import { Component } from '@angular/core';

@Component({
    selector: 'app-blogs',
    templateUrl: './blogs.component.html',
    styleUrls: ['./blogs.component.scss'],
    standalone: false
})
export class BlogsComponent {

}
